import { getSodaGlobalParams } from '@/common/utils/bridge'
import { util } from '@didi/soda-common'
const { env } = util

export async function initBridgeReport() {
  let globalParams = {}
  try {
    globalParams = await getSodaGlobalParams()
    window.BridgeTraceInit &&
      window.BridgeTraceInit(window.Omega, globalParams, {
        showLog: true,
        shouldReport: env.inNative,
      })
  } catch (e) {
    // console.warn('can\'t find getSodaGlobalParams')
  }
  // 初始化
}
